
import { Heart, Send, Users } from "lucide-react";

interface EmptyStateProps {
  type: 'matches' | 'received' | 'sent';
}

const EmptyState = ({ type }: EmptyStateProps) => {
  const getIconAndMessage = () => {
    switch (type) {
      case 'matches':
        return {
          icon: <Users className="h-12 w-12 text-luxury-pinkBright mb-4" />,
          title: 'Nenhum match ainda',
          message: 'Quando você e outra pessoa curtirem um ao outro, vocês terão um match e poderão começar uma conversa.'
        };
      case 'received':
        return {
          icon: <Heart className="h-12 w-12 text-luxury-pinkBright mb-4" />,
          title: 'Nenhuma curtida recebida',
          message: 'Quando alguém curtir seu perfil, você verá aqui.'
        };
      case 'sent':
        return {
          icon: <Send className="h-12 w-12 text-luxury-pinkBright mb-4" />,
          title: 'Nenhuma curtida enviada',
          message: 'Quando você curtir alguém, o perfil aparecerá aqui.'
        };
      default:
        return {
          icon: <Users className="h-12 w-12 text-luxury-pinkBright mb-4" />,
          title: 'Nenhuma conexão ainda',
          message: 'Comece a explorar perfis para encontrar pessoas compatíveis.'
        };
    }
  };

  const { icon, title, message } = getIconAndMessage();
  
  return (
    <div className="flex flex-col items-center justify-center text-center py-12">
      {icon}
      <h3 className="text-xl font-medium text-white mb-2">{title}</h3>
      <p className="text-white/70 max-w-sm">{message}</p>
    </div>
  );
};

export default EmptyState;
